import { useState } from "react";
import { Routes, Route, NavLink } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import MintPage from "./pages/MintPage";
import BurnClaimPage from "./pages/BurnClaimPage";
import FeeClaimPage from "./pages/FeeClaimPage";
import LpClaimPage from "./pages/LpClaimPage";
import GalleryPage from "./pages/GalleryPage";
import TokenDetailPage from "./pages/TokenDetailPage";
import ProofPage from "./pages/ProofPage";
import SkillPage from "./pages/SkillPage";
import ManifestoPage from "./pages/ManifestoPage";
import CodexAuthPage from "./pages/CodexAuthPage";
import ReferralRedirectPage from "./pages/ReferralRedirectPage";

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <nav className="nav" translate="no">
        <div className="nav__inner">
          <NavLink to="/" className="nav__logo" aria-label="CODE APE home" translate="no">
            <span className="gradient-text">CODE APE</span>
            <span className="nav__logo-caret" aria-hidden="true" />
            <span className="nav__logo-code" aria-hidden="true" translate="no">
              <span>summon()</span>
              <span>mint()</span>
              <span>hook.fee()</span>
              <span>0xC0DE</span>
            </span>
          </NavLink>
          <button
            type="button"
            className="nav__menu-button"
            aria-label={menuOpen ? "Close navigation" : "Open navigation"}
            aria-expanded={menuOpen}
            aria-controls="site-navigation"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </button>
          <ul id="site-navigation" className={`nav__links${menuOpen ? " nav__links--open" : ""}`}>
            <li><NavLink to="/" onClick={closeMenu} className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}>Home</NavLink></li>
            <li><NavLink to="/mint" onClick={closeMenu} className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}>Mint</NavLink></li>
            <li><NavLink to="/gallery" onClick={closeMenu} className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}>NFTs</NavLink></li>
            <li><NavLink to="/fees" onClick={closeMenu} className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}>Fees</NavLink></li>
            <li><NavLink to="/lp" onClick={closeMenu} className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}>LP</NavLink></li>
            <li><NavLink to="/burn" onClick={closeMenu} className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}>Burn &amp; Claim</NavLink></li>
            <li><NavLink to="/proof" onClick={closeMenu} className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}>Proof</NavLink></li>
            <li><NavLink to="/summon-skill" onClick={closeMenu} className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}>Summon Guide</NavLink></li>
            <li><NavLink to="/agent-auth" onClick={closeMenu} className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}>AI Agent Auth</NavLink></li>
            <li><NavLink to="/manifesto" onClick={closeMenu} className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}>Manifesto</NavLink></li>
          </ul>
        </div>
      </nav>

      <Routes>
        <Route path="/"       element={<LandingPage />} />
        <Route path="/mint"   element={<MintPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/nft/:tokenId" element={<TokenDetailPage />} />
        <Route path="/fees"   element={<FeeClaimPage />} />
        <Route path="/lp"     element={<LpClaimPage />} />
        <Route path="/burn"   element={<BurnClaimPage />} />
        <Route path="/proof"  element={<ProofPage />} />
        <Route path="/skill" element={<SkillPage />} />
        <Route path="/summon-skill" element={<SkillPage />} />
        <Route path="/agent-auth" element={<CodexAuthPage />} />
        <Route path="/codex-auth" element={<CodexAuthPage />} />
        <Route path="/auth" element={<CodexAuthPage />} />
        <Route path="/r/:code" element={<ReferralRedirectPage />} />
        <Route path="/manifesto" element={<ManifestoPage />} />
      </Routes>
    </>
  );
}
